import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RiPencilFill } from "react-icons/ri";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import TownAddAndEditModal from "./components/TownAddEditModal";
import { useGetTerritoryTownList } from "./UseTerriitory";
import { useGetOrgUnitsData } from "../../Employee/hooks/useEmployee";
import { FaEdit } from "react-icons/fa";



const TownColumns = (handleEditTown: (row: any) => void) => [
  {
    name: "Town",
    selector: (row: { Town: string }) => row.Town || "-",
    sortable: true,
    wrap: true
  },
  {
    name: "Town Code",
    selector: (row: { Town_Code: string }) => row.Town_Code || "-",
    sortable: true,
    wrap: true
  },
  {
    name: "Assign To Trip Type",
    selector: (row: { Assign_To_Trip_Type: string }) =>
      row.Assign_To_Trip_Type || "-",
    sortable: true,
    wrap: true
  },
  {
    name: "Others Trip Type",
    selector: (row: { Others_Trip_Type: string }) =>
      row.Others_Trip_Type || "-",
    sortable: true,
    wrap: true
  },
  {
    name: "Only NCA",
    selector: (row: { Only_NCA: string }) => row.Only_NCA || "-",
    sortable: true,
    wrap: true
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center">
        <button
          onClick={() => handleEditTown(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
        >
          <FaEdit style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
     width: '200px',
        wrap:true
  },
];


const Towns = () => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>("");
  const [rowData, setRowData] = useState<any>();
  const [filterData, setFilterData] = useState({
    Search: "",
    page: 1,
    limit: 10,
  });
  const location = useLocation();
  const TerritoryId = location.state.id;

  console.log('location',location)

  /// API response
  const { data: orgUnitsData, isLoading: orgDataLoading, isSuccess: orgDataSuccess } = useGetOrgUnitsData({ enable: true });
  const { data, isLoading, isSuccess } = useGetTerritoryTownList({
    enable: true,
    id: TerritoryId,
    params: {
      search: filterData.Search,
      page: filterData.page,
      limit: filterData.limit,
    },
  });

  const TownData = !isLoading && isSuccess && Array.isArray(data?.data?.data)
    ? data?.data?.data?.map((item: any) => ({
      id: item?.GeoTowns?.Itownid ?? "-",
      Town: item?.GeoTowns?.Stownname ?? "-",
      TownEdFilter: (item?.GeoTowns?.Stownname + ' | '+ item?.GeoTowns?.Stowncode)  || "-",
      Town_Code: item?.GeoTowns?.Stowncode ?? '-',
      Assign_To_Trip_Type: item?.AssignToTripType ?? "-",
      Others_Trip_Type: item?.OthersTripType ?? '-',
      Only_NCA: `${item?.OnlyNca}` || "-",
      TerritoryTownsId: item?.TerritoryTownsId ?? "-",
    })) : []


  const handleEditTown = (row: any) => {
    setCheckAddEditStatus("Edit");
    setRowData(row);
    setIsModalOpen(true);
  };
  const toggleModal = () => {
    setCheckAddEditStatus("Add");
    // setRowData(null)
    setIsModalOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo
    }))
  }

  const handleonChangeRowsPerPage = (newPerPage: any, page: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: page,
      limit: newPerPage
    }))
  }


  return (
    <div className="p-4">
      <PageHeader
        title={location.state.Name}
        buttons={[
          {
            label: "+ Add Territories Town",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
        ]}
      />
      <BasicDataTable
        paginationTotalRows={(!isLoading && isSuccess && data?.data?.pagination?.total_records) || 0}
        onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page)
        }}
        handleSearch={(val: any) => setFilterData((prev: any) => ({
          ...prev,
          Search: val
        }))}


        Title="Towns"
        columns={TownColumns(handleEditTown)}
        data={!isLoading && isSuccess && TownData || []}
      // headerContent={
      //   <div
      //     style={{
      //       marginBottom: "15px",
      //       display: "flex",
      //       justifyContent: "flex-end",
      //     }}
      //   >
      //     <RoundedDropdown
      //     options={(!orgDataLoading && orgDataSuccess && orgUnitsData?.data) || []}
      //       onSelect={(e) => {
      //         console.log(e);
      //       }}
      //       defaultLabel="All"
      //       width="auto"
      //       isShowHeading
      //       DropdownHeading="Org Unit"
      //       headingColor="#2e8dd3"
      //     />
      //   </div>
      // }
      />
      {isModalOpen && (<TownAddAndEditModal
        setCheckAddEditStatus={setCheckAddEditStatus}
        checkAddEditStatus={checkAddEditStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        TerritoryId={TerritoryId}
        rowData={rowData}
      />)
      }
    </div>
  );
};

export default Towns;
